import { useEffect, useState } from "react";

/**
 * Debounces a value by the given delay.
 * Updates only after the value stops changing.
 *
 * @param {*} value - Value to debounce
 * @param {number} delay - Delay in ms (default: 500)
 * @returns {*} Debounced value
 */
export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};
